import { Box, Button, Alert } from "@mui/material";
import { useRef, useState } from "react";
import "./UploadFileBtn.scss";
import file_img from "../../../Assets/upload_file.png";
import { FileUploader } from "react-drag-drop-files";
import { useTranslation } from "react-i18next";

const UploadFileBtn = ({
  onSubmit,
  multiple,
  fileType = null,
  title = "",
  buttonText = "Save",
  id = null,
  index = null,
  exdendStyle = false,
  classes = "",
  autoUpload = false,
}) => {
  const { t } = useTranslation("uploadFileBtn");

  const fileTypeDict = {
    excel:
      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
    file: ".pdf, .txt, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    imageAndPdf: ".pdf, image/*",
  };

  const fileType2Dict = {
    excel: ['CSV', 'XLSX', 'XLS'],
    imageAndPdf: ['PNG', 'PDF', 'JPG', 'JPEG']
  };

  const [files, setfiles] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploaderKey, setUploaderKey] = useState(0);

  const inputRef = useRef(null);

  const clearSelection = () => {
    setfiles(null);
    if (inputRef.current) inputRef.current.value = "";
    setUploaderKey((k) => k + 1);
  };

  const runSubmit = async (picked) => {
    if (!picked) return;
    setIsSubmitting(true);
    try {
      await onSubmit(picked, id, index);
      clearSelection();
    } finally {
      setIsSubmitting(false);
    }
  };

  const onChangeFile = async (event: any) => {
    const selected = event.target.files || [];
    const picked = multiple ? (selected ? Array.from(selected) : []) : (selected && selected[0] ? selected[0] : null);
    setfiles(picked);
    if (autoUpload) await runSubmit(picked);
  };

  const onChangeDragFile = async (file) => {
    setfiles(file);
    if (autoUpload) await runSubmit(file);
  };

  const hasFiles = multiple ? (files && files.length) : Boolean(files);

  return (
    <div>
      {!exdendStyle ? (
        <div>
          {title !== "" && <span className="upload-button-title">{title}</span>}
          <Button
            variant="contained"
            className="choose-btn"
            component="label"
            size="small"
            disabled={isSubmitting}
          >
            {t("choose_file")}
            <input
              ref={inputRef}
              type="file"
              accept={fileType ? fileTypeDict[fileType] : null}
              onChange={onChangeFile}
              multiple={multiple}
              hidden
            />
          </Button>
          {!multiple && <span className="text-files">
            {files ? (files.name.length > 10 ?
              files.name.slice(0, 10) + '...' : files.name) : t("no_file_selected")}
          </span>}
          {multiple && <span className="text-files">
            {files && files.length ? files.length : t("no")} {t("files_selected")}
          </span>}
          {!autoUpload && (
            <Button
              variant="outlined"
              className="upload-btn"
              onClick={() => runSubmit(files)}
              disabled={!hasFiles || isSubmitting}
            >
              {isSubmitting ? t("uploading") : buttonText}
            </Button>
          )}          {files && (
            <Box className="selected-file-row">
              <span className="selected-file-name">{multiple ? `${files.length} files selected` : files.name}</span>
              <Button size="small" onClick={clearSelection}>Clear</Button>
            </Box>
          )}
        </div>

      ) : (
        <Box className={"upload-box " + classes}>
          <span className="title">{title}</span>

          <FileUploader
            key={uploaderKey}
            handleChange={onChangeDragFile}
            classes="file-btn"
            types={fileType ? fileType2Dict[fileType] : undefined}
            name="file"
            multiple={multiple}
          >
            <img src={file_img} className="img-upload" alt="" />
            <Box className="text-upload">
              {!multiple && <span>
                {files ? (files.name.length > 20 ?
                  files.name.slice(0, 20) + '...' : files.name) : t("drag_or_choose_file")}
              </span>}
              {multiple && <span>
                {files && files.length ? files.length + ' ' + t("files_selected") : t("drag_or_choose_files")}
              </span>}
            </Box>
          </FileUploader>
          {/* <Button className="file-btn" component="label">
            <img src={file_img}></img>
            <input
              type="file"
              accept={fileType ? fileTypeDict[fileType] : null}
              onChange={onChangeFile}
              multiple={multiple}
              hidden
            />
            <Box className="text-upload">
              {!multiple && <span>
                {files ? (files.name.length > 20 ?
                  files.name.slice(0, 20) + '...' : files.name) : "Drag your file here or choose file"}
              </span>}
              {multiple && <span>
                {files && files.length ? files.length + ' files selected' : 'Drag your files here or choose files'}
              </span>}
            </Box>
          </Button> */}
          {!autoUpload && (
            <Button className="blue-btn" onClick={() => runSubmit(files)} disabled={!hasFiles || isSubmitting}>
              {isSubmitting ? t("uploading") : buttonText}
            </Button>
          )}        </Box>
      )}
    </div>
  );
};
export default UploadFileBtn;
